<template>
    <div>
        <div class="grid grid-cols-3 mobile-top">
            <div class="flex items-center pl-6">
                <img class="w-4" src="../../../assets/arrow/back.png" @click="clickBack()">
            </div>
            <div class="pt-2"><img class="logo-mobile-size m-auto" src="../../../assets/logo/tipcoin-logo-top.png"></div>
            <div class=" text-white flex justify-end items-center" v-if="isShowPoint">
                <div class="text-center pr-2">
                    <div class="text-18">{{lbl.topbar.coin}}</div>
                    <div class="flex items-center">
                        <div class="text-24">{{FilterNumberFormat(profile && profile.updated_points? profile.updated_points.points : 0)}}</div>
                        <div><img class="w-3 ml-2" src="../../../assets/icon/icon-tipcoin.png"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'TopBarBack',
    mixins: [AuthStatusMixin, LocaleMixin],
    props: {
        routeBack: { type:String , default: '' },
        isShowPoint: { type:Boolean , default: true }
    },
    methods: {
        // AuthStatusMixin
        onAccountInit: function() {
            if (this.isLogin) {
                console.log('profile', this.profile);
            }
        },
        clickBack: function() {
            if (window.location.pathname == '/carthistory') {
                window.location = '/home';
                return;
            }
            if(this.routeBack){
                this.$router.replace(this.routeBack)
            } else {
                this.$router.back();
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .logo-mobile-size {
        width: 53px; //53px
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
</style>
